/* global orbito */
/*
 * Web Component <orbe-geolocation-trigger>
 *
 * Au clic, ouvre la modal de l'app Orbe (orbito.openAndRefreshModal /
 * openModal / open). Si orbito n'est pas encore charge, retente jusqu'a
 * 40 fois avec 200ms d'intervalle.
 *
 * Necessite que l'app embed Orbe soit active dans le theme editor pour
 * que window.orbito existe.
 */

(function () {
  if (window.customElements && customElements.get('orbe-geolocation-trigger')) {
    return;
  }

  const openOrbeModal = () => {
    let attempts = 0;

    const getCandidate = () => {
      if (typeof window !== 'undefined' && typeof window.orbito !== 'undefined') return window.orbito;
      if (typeof orbito !== 'undefined') return orbito;
      return null;
    };

    const tryOpenOnce = () => {
      const candidate = getCandidate();

      try {
        if (candidate && typeof candidate.openAndRefreshModal === 'function') {
          candidate.openAndRefreshModal();
          return true;
        }

        if (candidate && typeof candidate.openModal === 'function') {
          candidate.openModal();
          return true;
        }

        if (candidate && typeof candidate.open === 'function') {
          candidate.open();
          return true;
        }
      } catch (error) {
        console.error('Orbe trigger: error while opening modal.', error);
        return false;
      }

      attempts += 1;
      if (attempts >= 40) {
        console.warn('Orbe trigger: orbito not ready yet.');
        return false;
      }

      window.setTimeout(tryOpenOnce, 200);
      return false;
    };

    tryOpenOnce();
  };

  class OrbeGeolocationTrigger extends HTMLElement {
    constructor() {
      super();
      this._onClick = () => {
        openOrbeModal();
      };
      this._onKeyDown = (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.click();
      };
    }

    connectedCallback() {
      if (!this.hasAttribute('role')) this.setAttribute('role', 'button');
      if (!this.hasAttribute('tabindex')) this.setAttribute('tabindex', '0');

      this.addEventListener('click', this._onClick, { capture: true });
      this.addEventListener('pointerdown', this._onClick, { capture: true });
      this.addEventListener('keydown', this._onKeyDown, { capture: true });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick, { capture: true });
      this.removeEventListener('pointerdown', this._onClick, { capture: true });
      this.removeEventListener('keydown', this._onKeyDown, { capture: true });
    }
  }

  customElements.define('orbe-geolocation-trigger', OrbeGeolocationTrigger);
})();
